import React, { useState } from "react";
import Modal from "../components/Modal";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Slider from "react-slick";
import Footer_new from "../components/Footer_new";

//translate
import { useTranslation } from "react-i18next";

const Wallet_digital = () => {
  const { t, i18n } = useTranslation();
  const [language, setLenguage] = useState("es");
  const [isOpen, setIsOpen] = useState(false);

        // Reemplaza estas URLs por tus imágenes locales si es necesario
const IPHONE_MOCKUP_URL = "https://img.invupos.com/clauweb/Hero/iMockup%20-%20iPhone%2015%20Pro%20Max%20%282%29.png";
const SVG_OVERLAY_URL = "https://img.invupos.com/clauweb/Hero/Vector%20128.svg";

  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 20000,
    slidesToShow: 6,
    slidesToScroll: 4,
    initialSlide: 0,
    cssEase: "linear",
    className: "wrapper",
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,

          // dots: true,
        },
      },
      {
        breakpoint: 812,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* <section className="bg-gradient-to-b bg-gradient-to-b from-[#040309] via-[#171635] to-[#2A255B]">
        <div className="px-4 py-28 mx-auto max-w-screen-xl sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:gap-32 lg:grid-cols-2">
            <div className="relative overflow-hidden lg:order-last order-last flex flex-col items-center">
              <img
                alt="Wallet Digital"
                src="https://img.invupos.com/clauweb/Wallet_digital/wallet-digital_2_gnskrw.png"
                className="object-cover w-full h-full sm:h-full"
              />
            </div>
            <div className="lg:py-28 text-left">
              <h1 className="text-7xl font-extrabold sm:text-9xl text-white">
                <span className="block">{t("clauwalletuppercase")}</span>
                <span
                  className="mt-4 w-full ml-auto px-12 py-4 rounded-r-full text-white text-7xl font-bold flex items-center justify-end"
                  style={{
                    background:
                      "linear-gradient(to right, white, #A9A8EE, #9290EA)",
                  }}
                >
                  {t("clauwallettitlespan")}
                </span>
              </h1>
              <p className="mt-8 text-gray-100 text-2xl w-full tracking-normal leading-relaxed">
                {t("clauwalletdescription")}
              </p>
              <div className="mt-8">
                <button
                  class="inline-block rounded-full border border-[#fff] bg-[#fff] px-16 py-4 text-lg font-medium text-[#1F2331] hover:bg-transparent hover:text-[#fff] focus:ring-3 focus:outline-hidden"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  {t("clauwalletcta")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}


<section className="relative w-full flex items-center overflow-hidden pt-10 pb-3">
  
  {/* Fondo con zoom */}
  {/* <div
  className="absolute inset-0 bg-cover bg-center"
  style={{
    backgroundImage:
      "url('https://img.invupos.com/clauweb/Hero/bg%20%281%29.png')",
    width: "120%",
    height: "120%",
    top: "-10%",
    left: "-10%",
    animation: "subtleMotion 20s ease-in-out infinite alternate",
  }}
/> */}

  <div className="w-full max-w-screen-2xl mx-auto px-6">
    
    {/* 👇 Cambiamos proporción del grid */}
    <div className="grid lg:grid-cols-[47%_53%] items-center gap-10">

      {/* LEFT */}
      <div className="max-w-3xl z-10">

        <h1 className="text-4xl md:text-5xl xl:text-[64px] font-medium text-[#0B2B5C] leading-[1.15] mb-6">
        {t("WALLET_HERO_TITLE_LINE1")}{" "}
        <span className="text-[#EC392A] font-extrabold">
          {t("WALLET_HERO_TITLE_HIGHLIGHT")}
        </span>{" "}
        {t("WALLET_HERO_TITLE_LINE2")}
        </h1>

        <p className="text-gray-600 text-base md:text-lg mb-8 max-w-md">
        {t("WALLET_HERO_DESCRIPTION")}
        </p>

        <button 
             onClick={() => {
              setIsOpen(true);
            }}
        className="bg-[#E73829] hover:bg-[#ff5a4c] transition text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg">
        {t("WALLET_HERO_BUTTON")}
        </button>
      </div>

      {/* RIGHT */}
      {/* <div className="relative flex justify-end">
        <img
          src="https://img.invupos.com/clauweb/Hero/Group%201597880418.png"
          alt="Clau App"
          className="w-[120%] max-w-none translate-x-10 drop-shadow-2xl"
        />
      </div> */}


<div className="relative flex justify-center lg:justify-center">

{/* 🎨 LÍNEAS */}
<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-3.png"
  alt=""
  className="
    absolute top-0 
    lg:left-auto lg:right-0 lg:translate-x-10
    w-[110%] sm:w-[115%] lg:w-[130%] max-w-none
    animate-lineDrawBlue
  "
/>

<img
  src="https://img.invupos.com/clauweb/Hero%20new/cover-img-clau-4.png"
  alt=""
  className="
    absolute top-0 
    lg:left-auto lg:right-0 lg:translate-x-10
    w-[110%] sm:w-[115%] lg:w-[130%] max-w-none
    animate-lineDrawRed
  "
/>

{/* 🧱 IMAGEN 1 */}
<img
  src="https://img.invupos.com/clauweb/Wallet_digital/wallet-digital-cta_wwfxnc%20%281%29.png"
  alt="Clau App"
  className="
    relative z-10

    w-[70%] sm:w-[50%] lg:w-[65%] max-w-none
    mx-auto
   lg:-left-10

    lg:translate-x-10
    drop-shadow-2xl

    opacity-0 animate-img1
  "
/>


</div>
    </div>
  </div>
</section>
<section className="w-full px-4 py-16">
  <div className="max-w-screen-2xl mx-auto bg-[#f5f5f5] rounded-3xl shadow-md px-6 md:px-12 py-16 md:py-20 relative overflow-hidden">
    
    <div className="grid lg:grid-cols-[40%_60%] gap-8 lg:gap-12 items-center">
      
      {/* 🖼️ Imagen */}
      <div className="relative flex justify-center lg:justify-start">
        
        <div className="absolute -left-4 -top-6 w-[240px] h-[340px] bg-[#e9b4ad] rounded-3xl" />

        <img
          src="https://img.invupos.com/clauweb/Wallet%20Digital/30065138144a0416affdf1d9894deb201d55af1a.png"
          alt=""
          className="relative rounded-2xl w-full  shadow-lg"
        />
      </div>

      {/* 📝 Texto */}
      <div className="max-w-[620px] mt-5">
        <h2 className="text-3xl md:text-[55px] text-black leading-none mb-6">
        {t("WALLET_SECTION_TITLE")}
        </h2>

        <p className="text-gray-600 text-base md:text-lg mb-5">
        {t("WALLET_SECTION_DESC_1")}
        </p>

        <p className="text-gray-600 text-base md:text-lg">
        {t("WALLET_SECTION_DESC_2")}
        </p>
      </div>
    </div>

    {/* ➡️ Botón */}
    <button    onClick={() => {
                      setIsOpen(true);
                    }} className="absolute bottom-8 right-8 w-12 h-12 rounded-full border border-red-500 flex items-center justify-center transition-all duration-300 hover:bg-red-500 hover:scale-110">
      <span className="text-red-500 hover:text-[#fff] text-xl">↗</span>
    </button>
  </div>
</section>

<section className="py-28 overflow-hidden">
      <div className="max-w-screen-2xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
          {/* LEFT IMAGE */}
          <div className="relative flex justify-center lg:justify-center">
            <img
              src="https://img.invupos.com/clauweb/Wallet_digital/WALLET-DIGITAL-5_tb3tqv.png"
              alt="Digital Wallet"
              className="w-[90%] max-w-[550px] drop-shadow-2xl"
              />
          </div>
          <div className="flex space-x-4 justify-center mt-4">
                  <a>
                    <div className="w-48 h-20">
                      <img
                        src="https://img.invupos.com/clauweb/Landing/Add_to_Google_Wallet_badge.png"
                        alt="Download on the App Store"
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </a>
                  <a>
                    <div className="w-48 h-20">
                      <img
                        src="https://img.invupos.com/clauweb/Landing/Add_to_Apple_Wallet_badge.png"
                        alt="Get it on Google Play"
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </a>
                </div>
              </div>

        
         {/* RIGHT CONTENT */}
         <div className="relative">
              <div className="space-y-8 relative">
                {/* ITEM 1 — tarjeta a la derecha, número a la izquierda */}
                <div className="relative flex items-center">
                  <span
                    className="absolute -left-5 text-[80px] font-light text-gray-200 leading-none select-none"
                    style={{ top: "50%", transform: "translateY(-50%)" }}
                  >
                    01
                  </span>
                  <div className="ml-auto w-[85%] bg-white rounded-3xl p-8 shadow-md">
                    <div className="flex items-start gap-4">
                      <div
                        className="w-10 h-10 rounded-full bg-[#FF0000] flex-shrink-0 mt-1"
                        style={{ top: "50%", transform: "translateY(50%)" }}
                      />
                      <div>
                        <h3 className="text-xl font-semibold mb-2 text-[#1F2937]">
                         {t("WALLET_ITEM_1_TITLE")}
                        </h3>
                        <p className="text-gray-500 text-base leading-relaxed">
                         {t("WALLET_ITEM_1_TEXT")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ITEM 2 — tarjeta a la izquierda, número a la derecha */}
                <div className="relative flex items-center">
                  <div className="mr-auto w-[85%] bg-white rounded-3xl p-8 shadow-md">
                    <div className="flex items-start gap-4">
                      <div
                        className="w-10 h-10 rounded-full bg-[#FF9719] flex-shrink-0 mt-1"
                        style={{ top: "50%", transform: "translateY(50%)" }}
                      />
                      <div>
                        <h3 className="text-xl font-semibold mb-2 text-[#1F2937]">
                         {t("WALLET_ITEM_2_TITLE")}
                        </h3>
                        <p className="text-gray-500 text-base leading-relaxed">
                         {t("WALLET_ITEM_2_TEXT")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <span
                    className="absolute lg:-right-1 -right-7 text-[80px] font-light text-gray-200 leading-none select-none"
                    style={{ top: "50%", transform: "translateY(-50%)" }}
                  >
                    02
                  </span>
                </div>

                {/* ITEM 3 — tarjeta a la derecha, número a la izquierda */}
                <div className="relative flex items-center">
                  <span
                    className="absolute -left-7 text-[80px] font-light text-gray-200 leading-none select-none"
                    style={{ top: "50%", transform: "translateY(-50%)" }}
                  >
                    03
                  </span>
                  <div className="ml-auto w-[85%] bg-white rounded-3xl p-8 shadow-md">
                    <div className="flex items-start gap-4">
                      <div
                        className="w-10 h-10 rounded-full bg-[#007A36] flex-shrink-0 mt-1"
                        style={{ top: "50%", transform: "translateY(50%)" }}
                      />
                      <div>
                        <h3 className="text-xl font-semibold mb-2 text-[#1F2937]">
                         {t("WALLET_ITEM_3_TITLE")}
                        </h3>
                        <p className="text-gray-500 text-base leading-relaxed">
                         {t("WALLET_ITEM_3_TEXT")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

  </div>
  
</div>

        </div>
        <div className="max-w-screen-2xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">

{/* CARD 1 */}
<div className="bg-[#f5f5f5] rounded-3xl shadow-md p-10 text-center flex flex-col items-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
  
  <div className="mb-6">
    <div className="w-12 h-12 border-2 border-blue-900 rounded-xl flex items-center justify-center text-blue-900 text-xl">
      +
    </div>
  </div>

  <h3 className="text-xl font-semibold text-gray-800 mb-3">
  {t("FEATURE_CARD_1_TITLE")}
  </h3>

  <p className="text-gray-500 text-base mb-6 max-w-[260px]">
  {t("FEATURE_CARD_1_TEXT")}
  </p>

  <button 
     onClick={() => {
      setIsOpen(true);
    }}
  className="bg-[#f25c54] text-white px-6 py-2 rounded-full text-sm transition hover:scale-105 hover:bg-[#e14b44]">
  {t("FEATURE_CARD_1_BUTTON")}
  </button>
</div>

{/* CARD 2 */}
<div className="bg-[#f5f5f5] rounded-3xl shadow-md p-10 text-center flex flex-col items-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
  
  <div className="mb-6">
    <div className="w-12 h-12 border-2 border-blue-900 rounded-xl flex items-center justify-center text-blue-900 text-xl">
      +
    </div>
  </div>

  <h3 className="text-xl font-semibold text-gray-800 mb-3">
  {t("FEATURE_CARD_2_TITLE")}
  </h3>

  <p className="text-gray-500 text-base mb-6 max-w-[260px]">
  {t("FEATURE_CARD_2_TEXT")}
  </p>

  <button 
     onClick={() => {
      setIsOpen(true);
    }}
  className="bg-[#f25c54] text-white px-6 py-2 rounded-full text-sm transition hover:scale-105 hover:bg-[#e14b44]">
  {t("FEATURE_CARD_2_BUTTON")}
  </button>
</div>

{/* CARD 3 */}
<div className="bg-[#f5f5f5] rounded-3xl shadow-md p-10 text-center flex flex-col items-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
  
  <div className="mb-6">
    <div className="w-12 h-12 border-2 border-blue-900 rounded-xl flex items-center justify-center text-blue-900 text-xl">
      +
    </div>
  </div>

  <h3 className="text-xl font-semibold text-gray-800 mb-3">
  {t("FEATURE_CARD_3_TITLE")}
  </h3>

  <p className="text-gray-500 text-base mb-6 max-w-[260px]">
  {t("FEATURE_CARD_3_TEXT")}
  </p>

  <button 
     onClick={() => {
      setIsOpen(true);
    }}
  className="bg-[#f25c54] text-white px-6 py-2 rounded-full text-sm transition hover:scale-105 hover:bg-[#e14b44]">
  {t("FEATURE_CARD_3_BUTTON")}
  </button>
</div>

</div>
      </div>
    </section>

      {/* <section className="px-4 py-16 mx-auto md:max-w-full lg:max-w-screen-xl lg:px-8 lg:py-20">
      <div className="relative rounded-3xl bg-gray-50 border border-gray-200 p-6 md:p-10">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          
          Imagen de los teléfonos
          <div className="order-last lg:order-first">
            <div className="relative mx-auto max-w-[430px]">
              <img
                src="https://img.invupos.com/clauweb/Wallet_digital/Wallet-digital-4_xftbjy.png"
                alt="Vista previa de la Clau Card en teléfonos"
                className="w-full h-auto object-contain drop-shadow-xl"
                loading="lazy"
              />
            </div>
          </div>

          Texto descriptivo
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-gray-900">
              ¿Qué es la <span className="text-gray-900">Clau card</span>?
            </h2>

            <p className="text-lg leading-8 text-gray-700">
              Es más que una herramienta de pago; es la forma perfecta de premiar a tus clientes frecuentes y fidelizarlos.
            </p>
            <p className="text-lg leading-8 text-gray-700">
              Cada transacción suma puntos que pueden canjear por descuentos, promociones exclusivas o beneficios únicos en tu negocio.
            </p>

            Botones de descarga
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="https://apps.apple.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Disponible en App Store"
                  className="h-12"
                />
              </a>
              <a
                href="https://play.google.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Disponible en Google Play"
                  className="h-12"
                />
              </a>
            </div>

            Botón de acción
            <button className="px-8 py-3 text-lg font-bold text-red-600 bg-white rounded-full hover:bg-gray-100 transition">
              Crea tu CLAU CARD
            </button>
          </div>
        </div>
      </div>
    </section> */}

      {/* Nueva Sección */}
      {/* <div className="px-4 py-16 mx-auto  md:max-w-full lg:max-w-screen-xl lg:px-8 lg:py-20">
        <div className="p-8 rounded-3xl sm:p-12 bg-[#F1F1F1]">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1d1d1f]">
            {t("claucardquestion")}
          </h2>
          <div className="flex flex-col lg:flex-row lg:mt-12 mt-6">
            <div className="lg:w-3/5 content-center">
              <div className="grid xl:grid-cols-3 lg:grid-cols-3 grid-cols-3 sm:grid-cols-3 md:grid-cols-3 gap-3 lg:gap-5 md:gap-5">

                <div className="rounded-2xl">
                  <div className="relative">
                    <img
                      className="rounded-2xl object-cover lg:h-44 h-28 h-28 h-44"
                      src="https://img.invupos.com/clauweb/Wallet%20Digital/Clau-card1.png"
                    />
                    <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black/80 to-transparent rounded-b-2xl">
                      <p className="hidden lg:block text-white text-center font-medium text-base mt-5">
                        {t("claucardfeaturepromociones")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="rounded-2xl">
                  <div className="relative">
                    <img
                      className="rounded-2xl object-cover lg:h-44 h-28 h-28 h-44"
                      src="https://img.invupos.com/clauweb/Wallet%20Digital/Clau-card2.png"
                    />
                    <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black/80 to-transparent rounded-b-2xl">
                      <p className="hidden lg:block text-white text-center font-medium text-base mt-5">
                        {t("claucardfeatureqr")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="rounded-2xl">
                  <div className="relative">
                    <img
                      className="rounded-2xl object-cover lg:h-44 h-28 h-28 h-44"
                      src="https://img.invupos.com/clauweb/Wallet%20Digital/Clau-card3.png"
                    />
                    <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black/80 to-transparent rounded-b-2xl">
                      <p className="hidden lg:block text-white text-center font-medium text-base mt-5">
                        {t("claucardfeatureanalisis")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-8">
                <button
                  class="inline-block rounded-full border border-[#fff] bg-[#fff] px-12 py-4 text-lg font-medium text-[#FF0000] focus:ring-3 focus:outline-hidden"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  {t("claucardcta")}
                </button>
              </div>
            </div>
            <div className="mb-6 lg:mb-0 lg:w-2/5 lg:pr-10 content-start text-justify lg:px-12 lg:mt-0 mt-6">
              <div className="text-gray-500 text-xl space-y-3 md:col-span-1 tracking-normal leading-relaxed">
                <p>{t("claucarddescription")}</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

{/* <div className="py-16 mx-auto md:max-w-full lg:max-w-screen-xl lg:px-8 lg:py-24 space-y-12">
  Título de la sección
  <h2 className="text-4xl sm:text-5xl font-extrabold text-[#1d1d1f] text-left">
    {t("claucardhandtitle1")}{" "}
    <span className="text-[#EC392A]">{t("claucardhandtitle2")}</span>{" "}
    {t("claucardhandtitle3")}
  </h2>

  Contenido imagen + texto
  <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12">
    Imagen más grande
    <div className="w-full lg:w-7/12 flex justify-center">
      <img
        src="https://img.invupos.com/clauweb/Wallet_digital/WALLET-DIGITAL-5_tb3tqv.png"
        alt="App demo"
        className="w-full max-w-[880px]"
      />
    </div>

    Texto más pequeño
    <div className="w-full lg:w-5/12 px-4 lg:px-8 space-y-8">
      <div className="grid grid-cols-1 gap-6 text-center">
        <div className="bg-gray-100 rounded-2xl p-6">
          <h3 className="text-2xl font-semibold text-red-600 mb-2">
            {t("claugiftcardtitle")}
          </h3>
          <p className="text-gray-500 text-lg">
            {t("claugiftcarddescription")}
          </p>
        </div>

        <div className="bg-gray-100 rounded-2xl p-6">
          <h3 className="text-2xl font-semibold text-red-600 mb-2">
            {t("claupunchcardtitle")}
          </h3>
          <p className="text-gray-500 text-lg">
            {t("claupunchcarddescription")}
          </p>
        </div>

        <div className="bg-gray-100 rounded-2xl p-6">
          <h3 className="text-2xl font-semibold text-red-600 mb-2">
            {t("clauloyaltycardtitle")}
          </h3>
          <p className="text-gray-500 text-lg">
            {t("clauloyaltycarddescription")}
          </p>
        </div>
      </div>
    </div>
  </div>
</div> */}
      

<section className="w-full bg-white pt-24 pb-16 px-6 lg:px-24 mb-32">
      {/* 1. Contenedor de Altura Completa (overflow-visible) */}
      <div className="max-w-screen-2xl mx-auto relative flex flex-col lg:flex-row items-center justify-between rounded-[40px] p-8 lg:p-20 shadow-sm border border-gray-100 overflow-visible">
        
        {/* SVG de Fondo (El Overlay) */}
        <div className="absolute inset-0 z-0 opacity-40 pointer-events-none">
          <img 
            src={SVG_OVERLAY_URL}
            alt="Fondo decorativo" 
            className="w-full h-full object-cover"
          />
        </div>

        {/* --- Columna Izquierda: El iPhone desbordado --- */}
        {/* 2. Contenedor relativo de altura completa para posicionar */}
        <div className="relative z-20 w-full lg:w-1/2 flex justify-center lg:justify-start h-[300px] lg:h-auto mb-16 lg:mb-0">
          {/* 3. El teléfono real: Posicionado Absoluto para desbordar */}
          <div className="absolute top-0 transform -translate-y-1/3 lg:-translate-y-1/2 w-[280px] md:w-[450px]  drop-shadow-2xl">
            <img 
              src="https://img.invupos.com/clauweb/Wallet_digital/Wallet-digital_3_zagume.png"
              alt="Madison Pass App"
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* --- Columna Derecha: Texto e Integraciones --- */}
        <div className="relative z-10 w-full text-right space-y-6 ml-auto">
        <p class="text-4xl text-[#1d1d1f] md:text-5xl">
                  {t("LOYALTY_TITLE")}
                </p>
  
  <p className="text-xl text-gray-600 max-w-xl ml-auto leading-relaxed">
  {t("LOYALTY_DESCRIPTION")}
  </p>
  <button className="mt-6 inline-block rounded-full border border-[#FE7066] bg-[#E73829] hover:bg-[#ff5a4c] lg:px-12 px-8 py-3 text-sm md:text-lg font-medium text-white hover:bg-transparent hover:text-[#FFF] focus:ring-3 focus:outline-hidden"
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    {t("LOYALTY_BUTTON")}
                  </button>
</div>
      </div>
    </section>




      {isOpen && <Modal setIsOpen={setIsOpen} />}
    </>
  );
};

export default Wallet_digital;